<div class="content" [ngClass]="banner.type">
  <div class="message">
    @if (!banner.html) {
      <span [innerHTML]="banner.content"></span>
    }
  </div>
  @if (banner.isDismissable) {
    <button
      (click)="closeBanner()"
      [attr.aria-label]="'common_close' | translate"
      type="button"
      class="is-dismissable goreact-btn btn-none">
      <span class="ficon-app-x"></span>
    </button>
  }
</div>
